import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "dialog-detail mb-s2 py-s1 flex align-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-form-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-arrow-down" })
], -1)
const _hoisted_4 = { class: "dialog-detail mt-s2 py-s1 flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "dialog-data mt-s4" }
const _hoisted_6 = { class: "dialog-footer dialog-footer-two-btn" }

import TokenIcon from '@/components/token/TokenIcon.vue';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';
import { format } from '@/utils/format';
import BridgeInfo from '@/views/pages/bridge/BridgeInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BridgeConfirmation',
  emits: ["cancel", "confirm"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const { bridgeForm } = useCardanoBridge();



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TokenIcon, {
          "icon-src": _unref(bridgeForm).fromToken.tokenIconUrl,
          symbol: _unref(bridgeForm).fromToken.unwrapWETH().symbol,
          full: "",
          size: "20"
        }, null, 8, ["icon-src", "symbol"]),
        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(bridgeForm).fromAmount)), 1)
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TokenIcon, {
          "icon-src": _unref(bridgeForm).toToken.tokenIconUrl,
          symbol: _unref(bridgeForm).toToken.unwrapWETH().symbol,
          full: "",
          size: "20"
        }, null, 8, ["icon-src", "symbol"]),
        _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(bridgeForm).toAmount)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BridgeInfo)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _ctx.$t('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _ctx.$t('bridge'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('confirm')))
      }, null, 8, ["label"])
    ])
  ], 64))
}
}

})